import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  enabled: {
    verticalAlign: 'middle',
    animation: 'name-type-appear 0.5s ease-out 0.55s',
    animationFillMode: 'backwards',
    color: 'rgb(0, 105, 225)',
  },
  disabled: {
    verticalAlign: 'middle',
    animation: 'name-type-appear 0.5s ease-out 0.55s',
    animationFillMode: 'backwards',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  icon: {
    marginRight: `${theme.spacing(1)} !important`,
    marginTop: `${theme.spacing(-1)} !important`,
    verticalAlign: 'middle',
  },
  editButton: {
    marginTop: `${theme.spacing(-2)} !important`,
    marginBottom: `${theme.spacing(-2)} !important`,
    marginLeft: `${theme.spacing(1)} !important`,
  },
  error: {
    color: 'rgb(244, 67, 54)',
    marginTop: theme.spacing(2),
  },
}))
